import { createHashRouter, RouterProvider } from 'react-router-dom';
import './App.css';

import Layout from './component/Layout/Layout';
import Homepage from './component/Homepage/Homepage';
import CarDetails from './component/CarDetails/CarDetails';
import ScrollToTop from './component/ScrollToTop/ScrollToTop';
import Login from './component/Login/Login';
import Register from './component/Register/Register';
import About from './component/About/About';
import Services from './component/Services/Services';
import Contact from './component/Contact/Contact';
import Cars from './component/Cars/Cars';
import PrivateRoute from './component/PrivateRoute'

function App() {
  const routers = createHashRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        { path: '/', element: <PrivateRoute><Homepage /></PrivateRoute> },
        { path: '/CarDetails/:id', element: <PrivateRoute><CarDetails /></PrivateRoute> },
        { path: '/login', element: <Login /> },
        { path: '/register', element: <Register /> },
        { path: '/about', element: <PrivateRoute><About /></PrivateRoute> },
        { path: '/services', element: <PrivateRoute><Services /></PrivateRoute> },
        { path: '/contact', element: <PrivateRoute><Contact /></PrivateRoute> },
        { path: '/cars', element: <PrivateRoute><Cars /></PrivateRoute> },
      ],
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={routers} future={{ v7_startTransition: true }} />
      <ScrollToTop />
    </div>
  );
}

export default App;
